import HomeIcon from "@mui/icons-material/Home";
import { Box, Stack, Typography } from "@mui/material";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { Button } from "Components/_Shared/Buttons/Button";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const Error403Page: React.FunctionComponent = (_) => {
  const { t } = useResource();

  const signOut = useSignOut();

  return (
    <UnauthenticatedLayout title={"403"}>
      <EmptyPage
        title={t(Resources.Errors.Error403.Title)}
        subtitle={t(Resources.Errors.Error403.Subtitle)}
        actions={
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={Spacing.L} mt={Spacing.XXL}>
            <UnstyledLink to="/">
              <Button startIcon={<HomeIcon />} size="large" variant="contained" color="primary">
                {t(Resources.Errors.Error404.Home)}
              </Button>
            </UnstyledLink>

            <Button onClick={() => signOut()}>{t(Resources.Common.SignOut)}</Button>
          </Stack>
        }
      />
    </UnauthenticatedLayout>
  );
};
